import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="text-muted-foreground text-sm tracking-wider uppercase">Loading…</div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // superadmin passes every role gate (platform owner)
  if (roles && !roles.includes(user.role) && user.role !== "superadmin") {
    return (
      <div className="p-10" data-testid="forbidden-view">
        <h2 className="font-display text-2xl mb-2">Restricted</h2>
        <p className="text-muted-foreground text-sm">
          Your role ({user.role}) does not have access to this page.
        </p>
      </div>
    );
  }

  return children;
}
